module.exports = {
  path: 'error',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Error'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/error/index.js